import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetProvidersData } from "../../../../../graphql/providers";
import { importUpdateNeeded } from "../../../../../redux/actions/flujocaja";
import closeMenuIcon from "../../../../../assets/pepper-icons/rightbar/icon_equis.svg";
import { ExcludeProvider } from "../../../../../graphql/providers";
import { importAlertState } from "../../../../../redux/actions/alert";
import LoadingSpinner from "../../../../general/js/spinnerLoading";

import "./reIncludeProvider.scss";
import { formatRut } from "../../../../../utils/formatter";
import { Button } from "semantic-ui-react";

export default function ReIncludeProvider({ closeMenu }) {
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.companyList);
  const { updateNeeded } = useSelector((state) => state.flujocaja);

  const [loading, setLoading] = useState(false)
  const [providerId, setProviderId] = useState("")

  const companyId = selectedCompany.id;
  const { error, excludeProvider } = ExcludeProvider();

  const { fetching, data, reexecuteQuery } = GetProvidersData(companyId);

  useEffect(() => {
    if (updateNeeded?.value) {
      reexecuteQuery({ requestPolicy: "network-only" });
      dispatch(importUpdateNeeded({ value: false }));
    }
  }, [updateNeeded]);

  const reIncludeProviderFunction = async (value) => {
    setLoading(true)
    setProviderId(value.rut)
    dispatch(
      importAlertState({
        content: "Estamos actualizando sus datos, por favor espere",
        state: "loading",
        duration: 5,
      })
    );
    const result = await excludeProvider({
      input: {
        companyId,
        provider: {
          name: value?.name,
          rut: value?.rut,
        },
        selected: false,
      },
    });
    if (result?.data) {
      dispatch(
        importAlertState({
          content: "Datos actualizados correctamente",
          state: "success",
          duration: 3,
        })
      );
      dispatch(importUpdateNeeded({ value: true }));
    }
    if (result?.error) {
      dispatch(
        importAlertState({
          content:
            "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
          state: "error",
          duration: 5,
        })
      );
    }
    setProviderId("")
    setLoading(false)
  };

  const top = -30;

  return (
    <div className="d-flex flex-column reincludeSearchTable">
    { fetching && !data ? (
        <div className="d-flex justify-content-center align-items-center w-100">
          <LoadingSpinner
            height="40px"
            afterHeight="40px"
            afterWidth="40px"
          />
        </div>
      ) : (
      data ? (
        data.Nominas.excludedProviders.length > 0 ? (
          data.Nominas.excludedProviders.map((el, index) => {
            return (
              <div className="d-flex reincludeRow">
                <div className="d-flex justify-content-between py-3 w-100 position-relative reincludeTable">
                  <div className="d-flex w-75">
                    <span
                      className="text-uppercase font-weight-bold position-absolute"
                      style={{ top }}
                      hidden={index > 0}
                    >
                      Proveedor
                    </span>
                    <div className="d-flex flex-column position-relative reincludeDetails">
                      <div className="text-truncate reconcileType">{ el.name || "Nombre desconocido" }</div>
                      <div className="font-weight-bold text-truncate position-relative reincludeName">{`${ formatRut(el.rut)}`}</div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-center reconcileTableAmount">
                    <Button type="button" color="blue" loading={loading && providerId == el.rut} size="tiny" onClick={() => reIncludeProviderFunction(el)}>Incluir</Button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div>No tiene proveedores excluidos.</div>
        )
      ) : (
        <div>No tiene proveedores excluidos.</div>
      ))}
    </div>
  )

/* return (
    <>
      <div className="providerBackground">
        <div className="providerBackground__container">
          <div className="providerBackground__container__title">
            <h5>Incluir Proveedor</h5>
            <img
              src={closeMenuIcon}
              alt="closeModal"
              className="providerBackground__container__title__img"
              onClick={() => closeMenu()}
            />
          </div>
          {data?.Nominas?.excludedProviders?.length > 0 ? (
            <>
              <div className="providerBackground__container__headerContainer">
                <div className="providerBackground__container__headerContainer__left">
                  Rut
                </div>
                <div className="providerBackground__container__headerContainer__center">
                  Nombre
                </div>
                <div className="providerBackground__container__headerContainer__right">
                  Incluir
                </div>
              </div>
              {data?.Nominas?.excludedProviders?.map((element, index) => {
                const lastItem =
                  data?.Nominas?.excludedProviders?.length - 1 === index
                    ? true
                    : false;
                return (
                  <div
                    className={`${
                      lastItem
                        ? "providerBackground__container__bodyContainer__lastItem"
                        : "providerBackground__container__bodyContainer"
                    } `}
                    key={index}
                  >
                    <div
                      className={`${
                        lastItem
                          ? "providerBackground__container__bodyContainer__lastItem__left"
                          : "providerBackground__container__bodyContainer__left"
                      }`}
                    >
                      {element?.rut}
                    </div>
                    <div
                      className={`${
                        lastItem
                          ? "providerBackground__container__bodyContainer__lastItem__center"
                          : "providerBackground__container__bodyContainer__center"
                      }`}
                    >
                      {element?.name}
                    </div>
                    <div
                      className={`${
                        lastItem
                          ? "providerBackground__container__bodyContainer__lastItem__right"
                          : "providerBackground__container__bodyContainer__right"
                      }`}
                    >
                      <button
                        className={`${
                          lastItem
                            ? "providerBackground__container__bodyContainer__lastItem__right__btn"
                            : "providerBackground__container__bodyContainer__right__btn"
                        }`}
                        onClick={() => reIncludeProviderFunction(element)}
                      >
                        Incluir
                      </button>
                    </div>
                  </div>
                );
              })}
              {fetching ? (
                <>
                  <div className="innerLoading">
                    <div className="innerLoading__spinner"></div>
                  </div>
                  <span className="loadingText">Actualizando...</span>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <div>
              {fetching ? (
                <>
                  <div className="providerBackground__container__headerContainer">
                    <div className="providerBackground__container__headerContainer__left">
                      Rut
                    </div>
                    <div className="providerBackground__container__headerContainer__center">
                      Nombre
                    </div>
                    <div className="providerBackground__container__headerContainer__right">
                      Incluir
                    </div>
                  </div>
                  <div className="providerBackground__container__bodyContainer__loadingProvider">
                    <div className="innerLoading">
                      <div className="innerLoading__spinner"></div>
                    </div>
                    <span className="loadingText">Actualizando...</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="providerBackground__container__headerContainer">
                    <div className="providerBackground__container__headerContainer__left">
                      Rut
                    </div>
                    <div className="providerBackground__container__headerContainer__center">
                      Nombre
                    </div>
                    <div className="providerBackground__container__headerContainer__right">
                      Incluir
                    </div>
                  </div>
                  <div className="providerBackground__container__bodyContainer__lastItemEmpty">
                    <span>No se encontraron proveedores excluidos.</span>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  ); */
}
